import { ChangeEvent, useState } from "react";
import { Card, Stack, Typography, Container, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { toast } from "react-toastify";

import { API_URL } from "Constants";

export default function Request() {
  const [formData, setFormData] = useState({ service_name: "", request: "" });
  const [requesting, setRequesting] = useState<boolean>(false);

  const submit = (e: any) => {
    e.preventDefault();
    let form = new FormData();
    form.append("service_name", formData.service_name);
    form.append("request", formData.request);

    axios
      .post(`${API_URL}/request/create`, form)
      .then((res) => {
        toast.success("با موفقیت ثبت شد");
        setRequesting(false);
      })
      .catch((err) => {
        toast.error("مشکلی در ثبت درخواست پیش آمد");
        setRequesting(false);
      });
  };
  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Container maxWidth="md">
      <Card sx={{ p: 3 }}>
        <Stack spacing={3}>
          <Typography align="center" variant="h5" sx={{ color: "secondary.main", fontWeight: "600" }}>
            درخواست اضافه شدن سرویس جدید
          </Typography>

          <form onSubmit={submit}>
            <Stack spacing={3} alignItems="center">
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography sx={{ color: "secondary.main" }}>نام سرویس</Typography>
                <TextField variant="filled" type="text" name="service_name" fullWidth onChange={handleChangeInput} />
              </Stack>

              <Stack spacing={1} sx={{ width: "100%" }}>
                <Typography sx={{ color: "secondary.main" }}>توضیحات</Typography>
                <TextField
                  variant="filled"
                  type="text"
                  multiline
                  rows={4}
                  name="request"
                  fullWidth
                  onChange={handleChangeInput}
                />
              </Stack>

              <LoadingButton
                variant="contained"
                loading={requesting}
                type="submit"
                color="secondary"
                sx={{ width: "200px", py: 1.5 }}
              >
                ثبت درخواست
              </LoadingButton>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Container>
  );
}
